module.exports = __webpack_public_path__ + "img/home-logo.adc9fffc.png";